module.exports = __webpack_public_path__ + "static/img/clever-cloud.0d6974c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clever-cloud.svg
// module id = 286
// module chunks = 2